import React from "react";

const Card = ({ index, img, id, flipCard, openCard, matchedCard }) => {
  let isFlipped = false;

  if (openCard?.includes(index)) isFlipped = true;

  if (matchedCard.includes(id)) isFlipped = true;

  return (
    <div
      className={`card ${isFlipped ? "flipped" : ""} `}
      onClick={() => flipCard(index)}
    >
      <div className="card_inner">
        <div className="front">
          <img src={img} alt="image" />
        </div>
        <div className="back">
          {/* {id} */}
          <img src="./images/questionMark.png" alt="image" />
        </div>
      </div>
    </div>
  );
};

export default Card;
